import { IsEnum, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../base.dto';
import { UserDto } from '../user.dto';
import { DermloopClinicalActionVariantEnum } from '@dermloop/static-values';

export class CreateDismissalDto {
  @IsNotEmpty()
  @IsString()
  medicalUnitId: string;
}

export class UpdateDismissalDto {
  @IsOptional()
  @IsNotEmpty()
  @IsString()
  medicalUnitId: string;
}

export class DismissalDto implements BaseDto {
  id: string;
  createdByUser?: UserDto;
  updatedByUser?: UserDto;
  deletedByUser?: UserDto;
  created?: string | Date;
  updated?: string | Date;
  deleted?: string | Date;

  @IsOptional()
  @IsNotEmpty()
  @IsString()
  medicalUnitId?: string;

  @IsOptional()
  @IsEnum(DermloopClinicalActionVariantEnum)
  clinicalAction?: DermloopClinicalActionVariantEnum;
}
